/**
 * Pick-Operator picker removed 2026-06 — the logged-in user is the operator;
 * the backend derives operator attribution from the session. This module now
 * only adapts the auth identity to the legacy useActiveOperator() shape the
 * edit components consume.
 */
import { useAuth } from '../lib/auth'

/** Active operator — the logged-in user's email (null when not authed). The
 *  setter is a no-op: identity follows the login, not a local picker. Kept as
 *  a `[value, setter]` tuple so the edit components (EditableCell, StateToggle,
 *  Keywords, PendingTray) need no change — they only read [0]. */
export function useActiveOperator(): [string | null, (slug: string | null) => void] {
  const { user } = useAuth()
  return [user?.email ?? null, () => {}]
}
